import * as React from 'react'
import Svg, { Defs, G, LinearGradient, Path, Rect, Stop, SvgProps } from 'react-native-svg'

export const PostCompleteUpswing = (props: SvgProps) => (
  <Svg width={230} height={230} viewBox='0 0 230 230' fill='none' {...props}>
    <G>
      <Rect x={15} y={10} width={200} height={200} rx={100} fill='url(#paint0_linear_4150_12212)' />
      <Rect
        x={16}
        y={11}
        width={198}
        height={198}
        rx={99}
        stroke='url(#paint1_linear_4150_12212)'
        strokeWidth={2}
      />
    </G>
    <G fill='#0175FD' stroke='#054BDC' strokeWidth={0.5}>
      <Path d='M114.01 151.885h.001a24.652 24.652 0 0017.872-6.961 24.644 24.644 0 007.477-17.662v0-42.239 0a2.882 2.882 0 011.775-2.666c.349-.146.724-.22 1.103-.22h2.092a2.876 2.876 0 012.668 1.78c.145.35.219.726.218 1.106v42.239a32.528 32.528 0 01-20.597 30.222 32.506 32.506 0 01-12.663 2.256c-17.732-.415-31.706-15.344-31.706-33.089v-19.43a2.889 2.889 0 012.886-2.886h2.108a2.887 2.887 0 012.878 2.886v19.522c0 13.394 10.489 24.744 23.888 25.142z' />
      <Path d='M96.52 74.185h0a2.878 2.878 0 012.878-2.887h2.091a2.881 2.881 0 012.878 2.886v52.802a10.553 10.553 0 009.355 10.604l.005.001a10.363 10.363 0 007.941-2.64 10.367 10.367 0 003.406-7.645V68.623a2.888 2.888 0 012.887-2.887h2.091a2.884 2.884 0 012.878 2.887v58.657a18.247 18.247 0 01-1.459 7.128 18.234 18.234 0 01-17.452 11.073c-9.844-.379-17.5-8.784-17.5-18.653V74.185z' />
      <Path d='M113.691 60.25h2.084a2.876 2.876 0 012.885 2.878v64.186a3.933 3.933 0 01-3.924 3.932 3.931 3.931 0 01-3.931-3.932V63.128a2.874 2.874 0 012.886-2.878z' />
    </G>
    <Defs>
      <LinearGradient
        id='paint0_linear_4150_12212'
        x1={115}
        y1={10}
        x2={120}
        y2={216}
        gradientUnits='userSpaceOnUse'
      >
        <Stop stopColor='#5FECFD' />
        <Stop offset={1} stopColor='#13BCFF' />
      </LinearGradient>
      <LinearGradient
        id='paint1_linear_4150_12212'
        x1={115}
        y1={10}
        x2={115}
        y2={210}
        gradientUnits='userSpaceOnUse'
      >
        <Stop stopColor='#054BDC' />
        <Stop offset={1} stopColor='#5FECFD' />
      </LinearGradient>
    </Defs>
  </Svg>
)
